const escapeHtml = (text = '') =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const formatInlineMarkdown = (text = '') => {
  const normalized = String(text || '').replace(/\\([*_`])/g, '$1');
  const escaped = escapeHtml(normalized);

  const withLinks = escaped.replace(
    /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
    '<a href="$2">$1</a>'
  );
  const withBold = withLinks.replace(
    /(\*\*|__)(.*?)\1/g,
    '<strong>$2</strong>'
  );
  const withItalic = withBold.replace(/(\*|_)([^*_]+)\1/g, '<em>$2</em>');
  const withCode = withItalic.replace(/`([^`]+)`/g, '<code>$1</code>');

  return withCode;
};

export const markdownToSafeHtml = (markdown = '') => {
  const normalized = String(markdown || '')
    .replace(/\r\n/g, '\n')
    // Support escaped line breaks coming from stored payloads: "\\\n"
    .replace(/\\[ \t]*\n/g, '\n')
    // Drop standalone slash lines left by escaped formatting
    .replace(/^\s*\\\s*$/gm, '')
    .trim();
  if (!normalized) return '';

  const lines = normalized.split('\n');
  const htmlParts = [];
  let inUnorderedList = false;

  const closeList = () => {
    if (inUnorderedList) {
      htmlParts.push('</ul>');
      inUnorderedList = false;
    }
  };

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (!line) {
      closeList();
      continue;
    }

    const listMatch = line.match(/^[-*]\s+(.+)$/);
    if (listMatch) {
      if (!inUnorderedList) {
        htmlParts.push('<ul style="margin: 0 0 12px 20px; padding: 0;">');
        inUnorderedList = true;
      }
      htmlParts.push(
        `<li style="margin: 0 0 4px 0;">${formatInlineMarkdown(listMatch[1])}</li>`
      );
      continue;
    }

    closeList();
    htmlParts.push(
      `<p style="margin: 0 0 12px 0;">${formatInlineMarkdown(line)}</p>`
    );
  }

  closeList();
  return htmlParts.join('');
};

export const getSettingMarkdownValue = (settingValue = '') => {
  const rawValue = String(settingValue || '').trim();
  if (!rawValue) return '';

  try {
    const parsed = JSON.parse(rawValue);

    if (typeof parsed === 'string') return parsed.trim();

    if (Array.isArray(parsed) && parsed.length > 0) {
      const first = parsed[0];
      if (typeof first === 'string') return first.trim();
      if (first && typeof first === 'object') {
        const candidate =
          first?.markdown ??
          first?.value ??
          first?.content ??
          first?.instructions;
        return typeof candidate === 'string' ? candidate.trim() : '';
      }
    }

    if (parsed && typeof parsed === 'object') {
      const candidate =
        parsed?.markdown ??
        parsed?.value ??
        parsed?.content ??
        parsed?.instructions;
      return typeof candidate === 'string' ? candidate.trim() : '';
    }
  } catch (_) {
    // Fall through to raw string
  }

  return rawValue;
};
